/**
 * Web entry point for Blue HMS App
 * @format
 */

// Import crypto polyfill FIRST before any other imports that might use uuid/crypto
import 'react-native-get-random-values';

import { AppRegistry } from 'react-native';
import App from './src/App';
import appConfig from './app.json';

// Register the app for web
AppRegistry.registerComponent(appConfig.name, () => App);

// Start the app
AppRegistry.runApplication(appConfig.name, {
  initialProps: {},
  rootTag: document.getElementById('root'),
});

